import { servicesAdmins } from 'services';
import useMutationHookWrapper, {
    TAsyncStatesHandlers,
} from 'hooks/use-mutation-hook-wrapper';
import { admins as typesAdmin, network } from 'types';

const useAdminsDel = (
    arg0?: TAsyncStatesHandlers<network.TQueryDefWrapper<null>, string>,
) => {
    return useMutationHookWrapper<
        network.TQueryDefWrapper<null>,
        string,
        typesAdmin.TAdminsDelParams
    >({
        mutationFn: servicesAdmins.del,
        mutationConfig: {},
        asyncStateHandlers: arg0,
    });
};

export default useAdminsDel;
